import { render, staticRenderFns } from "./Forum.vue?vue&type=template&id=0218b26a&"
import script from "./Forum.vue?vue&type=script&lang=js&"
export * from "./Forum.vue?vue&type=script&lang=js&"
import style0 from "./Forum.vue?vue&type=style&index=0&id=0218b26a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports